export interface UserAccount {
  userID: string;
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  companyname: string;
  taxnr: string;
  city: string;
  street: string;
  building: string;
  postcode: string;
  consigneeaddresses: Array<{}>;
  shipperaddresses: Array<{}>;
  notifications: Object;
  [key: string]: string | number | any;
}
export interface StatusLabels {
  processing: string;
  pickedup: string;
  origin: string;
  transit: string;
  destination: string;
  delivered: string;
  [key: string]: string | number | any;
}
export interface PaymentLabels {
  processing: string;
  open: string;
  overdue: string;
  paid: string;
  [key: string]: string | number | any;
}

export interface UserDashboardState {
  activeStep: string;
  userAccount: UserAccount;
  orders: Array<{}>;
  messages: Object;
  accountFetched: boolean;
  modalOpen: boolean;
  [key: string]: string | number | any;
}

export const defaultUserDashboardState: UserDashboardState = {
  activeStep: "Dashboard",
  userAccount: {
    userID: "",
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    companyname: "",
    taxnr: "",
    city: "",
    street: "",
    building: "",
    postcode: "",
    consigneeaddresses: [{}],
    shipperaddresses: [{}],
    notifications: {},
  },
  statusLabels: {
    processing: "Waiting to be processed",
    pickedup: "Picked up from shipper",
    origin: "At origin destination",
    transit: "Shipped (in transit)",
    destination: "Arrived at destination airport",
    delivered: "Delivered to consignee",
  },
  paymentLabels: {
    processing: "Under elaboration",
    open: "Open",
    overdue: "Overdue",
    paid: "Paid",
  },
  orders: [{}],
  messages: {},
  accountFetched: false,
  modalOpen: false,
};
